import { MarkerType, Position } from "@vue-flow/core";

export const alarmTemplates = {
  ON_OFF: {
    nodes: [
      {
        id: "N-1",
        label: "",
        type: "custom",
        data: {
          handles: [
            {
              id: "a",
              type: "source",
              position: Position.Bottom,
              style: "right: 50%;",
            },
          ],
        },
        position: { x: 241, y: 50 },
        class: "alarm-node-initial",        
      },
      {
        id: "N-2",
        label: "ALARM ON",
        position: { x: 180, y: 190 },
      },
      {
        id: "N-3",
        label: "",
        type: "custom",
        data: {
          handles: [
            {
              id: "a",
              type: "target",
              position: Position.Top,
              style: "right: 50%;",
            },
          ],
          type: 'final',
        },
        position: { x: 241, y: 340 },
        class: "alarm-node-final",
      },
    ],
    edges: [
      {
        id: "E-1",
        source: "N-1",
        sourceHandle: "a",
        target: "N-2",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION ON",
        type: "smoothstep",
      },
      {
        id: "E-2",
        source: "N-2",
        target: "N-3",
        targetHandle: "a",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION OFF",
        type: "smoothstep",
      },
    ],
  },
  ACK: {
    nodes: [
      {
        id: "A-N-1",
        label: "",
        type: "custom",
        data: {
          handles: [
            {
              id: "a",
              type: "source",
              position: Position.Bottom,
              style: "right: 50%;",
            },
          ],
        },
        position: { x: 121, y: 50 },
        class: "alarm-node-initial",        
      },
      {
        id: "A-N-2",
        label: "ALARM ON",
        type: "custom",
        data: {
          label: "ALARM ON",
          handles: [
            {
              id: "a",
              type: "target",
              position: Position.Top,
              style: "right: 50%;",
            },
            {
              id: "b",
              type: "source",
              position: Position.Bottom,
              style: "right: 50%;",
            },
            {
              id: "c",
              type: "source",
              position: Position.Right,
              style: "bottom: 50%;",
            },
          ],
        },
        position: { x: 60, y: 150 },
        class: "alarm-node-custom",
      },
      {
        id: "A-N-3",
        label: "ALARM ON - ACKED",
        position: { x: 350, y: 150 },
        targetPosition: Position.Left,
      },
      {
        id: "A-N-4",
        label: "ALARM OFF",
        position: { x: 60, y: 300 },
        sourcePosition: Position.Right,
      },
      {
        id: "A-N-5",
        label: "ALARM OFF - ACKED",
        type: "custom",
        data: {
          handles: [
            {
              id: "a",
              type: "target",
              position: Position.Top,
              style: "right: 50%;",
            },
            {
              id: "b",
              type: "target",
              position: Position.Left,
              style: "bottom: 50%;",
            },
          ],
          type: 'final',
        },
        position: { x: 411, y: 306 },
        class: "alarm-node-final",
      },
    ],
    edges: [
      {
        id: "A-E-1",
        source: "A-N-1",
        sourceHandle: "a",
        target: "A-N-2",
        targetHandle: "a",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION ON",
        type: "straight",
      },
      {
        id: "A-E-2",
        source: "A-N-2",
        sourceHandle: "b",
        target: "A-N-4",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION OFF",
        type: "straight",
      },
      {
        id: "A-E-3",
        source: "A-N-3",
        target: "A-N-5",
        targetHandle: "a",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION OFF",
        type: "straight",
      },
      {
        id: "A-E-4",
        source: "A-N-2",
        sourceHandle: "c",
        target: "A-N-3",
        markerEnd: MarkerType.ArrowClosed,
        label: "ACK RECEIVED",
        type: "straight",
      },
      {
        id: "A-E-5",
        source: "A-N-4",
        target: "A-N-5",
        targetHandle: "b",
        markerEnd: MarkerType.ArrowClosed,
        label: "ACK RECEIVED",
        type: "straight",
      },
    ],
  },
  ACK_RESET: {
    nodes: [
      {
        id: "R-N-1",
        label: "",
        type: "custom",
        data: {
          handles: [
            {
              id: "a",
              type: "source",
              position: Position.Bottom,
              style: "right: 50%;",
            },
          ],
        },
        position: { x: 121, y: 50 },
        class: "alarm-node-initial",        
      },
      {
        id: "R-N-2",
        label: "ALARM ON",
        type: "custom",
        data: {
          label: "ALARM ON",
          handles: [
            {
              id: "a",
              type: "target",
              position: Position.Top,
              style: "right: 50%;",
            },
            {
              id: "b",
              type: "source",
              position: Position.Bottom,
              style: "right: 50%;",
            },
            {
              id: "c",
              type: "source",
              position: Position.Right,
              style: "bottom: 50%;",
            },
          ],
        },
        position: { x: 60, y: 150 },
        class: "alarm-node-custom",
      },
      {
        id: "R-N-3",
        label: "ALARM ON - ACKED",
        position: { x: 350, y: 150 },
        targetPosition: Position.Left,
      },
      {
        id: "R-N-4",
        label: "ALARM OFF",
        position: { x: 60, y: 300 },
        sourcePosition: Position.Right,
      },
      {
        id: "R-N-5",
        label: "ALARM OFF - ACKED",
        type: "custom",
        data: {
          label: "ALARM OFF - ACKED",
          handles: [
            {
              id: "a",
              type: "target",
              position: Position.Top,
              style: "right: 50%;",
            },
            {
              id: "b",
              type: "target",
              position: Position.Left,
              style: "bottom: 50%;",
            },
            {
              id: "c",
              type: "source",
              position: Position.Bottom,
              style: "right: 50%;",
            },
          ],
        },
        position: { x: 350, y: 300 },
        class: "alarm-node-custom",
      },
      {
        id: "R-N-6",
        label: "ALARM OFF - ACKED",
        type: "custom",
        data: {
          handles: [
            {
              id: "a",
              type: "target",
              position: Position.Top,
              style: "right: 50%;",
            },
          ],
          type: 'final',
        },
        position: { x: 411, y: 450 },
        class: "alarm-node-final",
      },
    ],
    edges: [
      {
        id: "R-E-1",
        source: "R-N-1",
        sourceHandle: "a",
        target: "R-N-2",
        targetHandle: "a",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION ON",
        type: "straight",
      },
      {
        id: "R-E-2",
        source: "R-N-2",
        sourceHandle: "b",
        target: "R-N-4",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION OFF",
        type: "straight",
      },
      {
        id: "R-E-3",
        source: "R-N-3",
        target: "R-N-5",
        targetHandle: "a",
        markerEnd: MarkerType.ArrowClosed,
        label: "CONDITION OFF",
        type: "straight",
      },
      {
        id: "R-E-4",
        source: "R-N-2",
        sourceHandle: "c",
        target: "R-N-3",
        markerEnd: MarkerType.ArrowClosed,
        label: "ACK RECEIVED",
        type: "straight",
      },
      {
        id: "R-E-5",
        source: "R-N-4",
        target: "R-N-5",
        targetHandle: "b",
        markerEnd: MarkerType.ArrowClosed,
        label: "ACK RECEIVED",
        type: "straight",
      },
      {
        id: "R-E-6",
        source: "R-N-5",
        sourceHandle: "c",
        target: "R-N-6",
        targetHandle: "a",
        markerEnd: MarkerType.ArrowClosed,
        label: "RESET RECEIVED",
        type: "straight",
      },
    ],
  },
};
